import { WSPillProps } from "@wingspanhq/fe-component-library";
import { PayableRow, PayableStatus } from "@wingspanhq/wingspan-api-sdk";

const PILL_DRAFT: WSPillProps = { theme: "neutral", text: "Draft" };
const PILL_OVERDUE: WSPillProps = { theme: "error", text: "Overdue" };
const PILL_AWAITING_PAYMENT: WSPillProps = {
  theme: "warning",
  text: "Awaiting payment"
};
const PILL_IN_TRANSIT: WSPillProps = { theme: "blue", text: "In transit" };
const PILL_PAID: WSPillProps = { theme: "success", text: "Paid" };
const PILL_OFF_PLATFORM: WSPillProps = {
  theme: "neutral",
  text: "Paid off-platform"
};
const PILL_CANCELLED: WSPillProps = { theme: "neutral", text: "Cancelled" };
const PILL_REFUNDED: WSPillProps = { theme: "neutral", text: "Refunded" };
const PILL_RETURNED: WSPillProps = { theme: "error", text: "Returned" };
const PILL_UNKNOWN: WSPillProps = { theme: "neutral", text: "Unknown" };

const isPastDue = (payable: PayableRow): boolean =>
  !!payable.dueDate && payable.dueDate.getTime() < Date.now();

/**
 * Client-facing status pill for a `PayableRow`. Unlike the payer/AP-team
 * pill (`modules/Payables/.../getStatusColumn.ts`), this has no
 * approval-workflow or dispute states — a client only ever sees payables
 * already issued to them.
 */
export const getPayableStatusPill = (payable: PayableRow): WSPillProps => {
  switch (payable.status) {
    case PayableStatus.CREATED:
      return PILL_DRAFT;
    case PayableStatus.OPENED:
    case PayableStatus.PENDING:
      return isPastDue(payable) ? PILL_OVERDUE : PILL_AWAITING_PAYMENT;
    case PayableStatus.PAYMENT_IN_TRANSIT:
      return PILL_IN_TRANSIT;
    case PayableStatus.PAID:
    case PayableStatus.PARTIALLY_PAID:
      return PILL_PAID;
    case PayableStatus.PAID_OFF_PLATFORM:
      return PILL_OFF_PLATFORM;
    case PayableStatus.CANCELLED:
      return PILL_CANCELLED;
    case PayableStatus.REFUNDED:
    case PayableStatus.PARTIALLY_REFUNDED:
      return PILL_REFUNDED;
    case PayableStatus.RETURNED:
      return PILL_RETURNED;
    default:
      return PILL_UNKNOWN;
  }
};
